// extracted by mini-css-extract-plugin
module.exports = {"participantHistory":"Participant_participantHistory__ae-hz"};